export const ADD_STORE = 'ADD_STORE'
export const LOAD_STORE = 'LOAD_STORE'
export const LOAD_WAREHOUSES = 'LOAD_WAREHOUSES'
export const UPDATE_STORE = 'UPDATE_STORE'
export const UPDATE_CURRENT_STORE = 'UPDATE_STORE'
export const DELETE_STORE = 'DELETE_STORE'
export const UPDATE_STORE_PRODUCT = 'UPDATE_STORE_PRODUCT'
